import { api } from '@/utils/api';
import { Product, ProductCreate, ProductUpdate } from '@/types/product';

export interface ProductBulkDelete {
  productIds: string[];
}

export const productApi = {
  // Get all products for the company
  getAll: async (includeInactive: boolean = true): Promise<Product[]> => {
    const response = await api.get('/api/products/', {
      params: { include_inactive: includeInactive }
    });
    return response.data;
  },

  // Get product by ID
  getById: async (id: string): Promise<Product> => {
    const response = await api.get(`/api/products/${id}/`);
    return response.data;
  },

  // Create new product
  create: async (data: ProductCreate): Promise<Product> => {
    const response = await api.post('/api/products/', data);
    return response.data;
  },

  // Update product
  update: async (id: string, data: ProductUpdate): Promise<Product> => {
    const response = await api.put(`/api/products/${id}`, data);
    return response.data;
  },

  // Bulk delete products
  bulkDelete: async (data: ProductBulkDelete): Promise<{ successCount: number; failedCount: number }> => {
    const response = await api.post('/api/products/delete', {
      productIds: data.productIds
    });
    return response.data;
  },
};